<template>
  <div id="contact" class="bottom-corner-background-img main-component-container">
      <v-card-title class="component-title">
          <img alt="AboutTitle" v-bind:src="require('@/assets/Contact.png')" class="component-title-image">
      </v-card-title>
      <div class="component-content">
        <div class="row">
          <div class="component-locale-text">
                <p v-for="(text, index) in $i18n.messages[$i18n.locale].contact.content" :key="index">{{ text }}</p>
          </div>
        </div>
      </div>
      <br>
  </div>
</template>

<script>
export default {
    name: 'Contact',
    data () {
        return {
            valid: false,
            formSuccessful: false,
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length <= 10) || 'Name must be less than 10 characters',
            ],
            messageRules: [
                v => !!v || 'Message is required',
                v => (v && v.length <= 255) || 'Message must be less than 255 characters',
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                //eslint-disable-next-line
                v => new RegExp("^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$").test(v) || 'E-mail must be valid',
            ],
            form: {
                name: undefined,
                email: undefined,
                message: undefined
            }
        }
    },
    methods: {
        validate () {
            this.$refs.contactForm.validate()
            this.handleSubmit()
            this.reset()
        },
        reset () {
            this.$refs.contactForm.reset()
            this.valid = false
            this.formSuccessful = false
        },
        encode(data) {
            return Object.keys(data)
                .map(
                key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
            )
            .join("&");
        },
        handleSubmit() {
            fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: this.encode({
                    "form-name": "contactForm",
                    ...this.form
                })
            })
            .then(() => {
                this.formSuccessful = true
            })
            .catch((e) => {
                console.log("something went wrong: " + e)
            });
        }
    }
}
</script>

<style scoped>
.component-title-image{
  width: 650px;
}
</style>
